import React from 'react';

const NotFound = () => (
  <div style={{ padding: 32, color: '#b91c1c' }}>
    <h2>404 - Not Found</h2>
    <p>The page you are looking for does not exist.</p>
  </div>
);

export default NotFound; 